<template>
  <div class="configurations-agency-lre">
    <b-container fluid>
      <b-container>
        <appAgencyLre></appAgencyLre>
      </b-container>
      <router-view />
    </b-container>
  </div>
</template>

<script>
import appConfigurationsNav from "@/components/snippets/ConfigurationsNav";

export default {
  components: {
    appConfigurationsNav,
    appAgencyLre: () => import("@/components/configurations/agency-lre/AgencyLre.vue"),
  },
};
</script>
